module.exports = __webpack_public_path__ + "img/24.19e3e881.jpg";